/**
 * OAuth's keys
 */
export const StorageOAuth = {
  externalSignIn: 'external_sign-in',
  externalSignUp: 'external_sign-up',
  externalSignError: 'external_sign-error'
};
